import React from 'react';
import { IconCheck } from '../icons';

type Props = {
  id?: string;
  done?: boolean;
  icon: React.ReactNode;
  title: string;
  body: React.ReactNode;
  action: React.ReactNode;
};

export function RequirementRow({ id, done, icon, title, body, action }: Props) {
  return (
    <div className={`req${done ? ' done' : ''}`} id={id} {...(id ? { 'data-reset': true } : {})}>
      <div className={`req-ico ${done ? 'done' : 'todo'}`}>
        <span className="ico-todo">{icon}</span>
        <span className="ico-done"><IconCheck /></span>
      </div>
      <div className="req-txt">
        <h4>{title}</h4>
        {typeof body === 'string' ? <p>{body}</p> : body}
      </div>
      <div className="req-act">{action}</div>
    </div>
  );
}
